export default __webpack_public_path__ + "static/media/apple.c040b25f.png";